import VueCookie from 'vue-cookie'

// configs
import configs from '@/config'

const initOptions = {
  expires: 365,
  sameSite: 'none',
  secure: true,
}

const otherRegions = ['eu']

const transformKey = (key: string): string => {
  if (!key) return key

  let prefix = ''

  if (otherRegions.includes(configs.region)) {
    prefix += `${configs.region}-`
  }

  if (prefix) {
    return prefix + key
  }

  return key
}

const setValueByDomain = <T>(key: string, value: T, options = initOptions): void => {
  if (!window.location.hostname.includes(configs.domain)) return

  if (configs.domain === 'ahaslides.eu') return

  const newOptions = {
    ...options,
    domain: configs.domain,
  }

  const newKey = transformKey(key)
  VueCookie.set(newKey, value || '', newOptions)
}

const setValue = <T>(key: string, value: T, options = initOptions): void => {
  const newKey = transformKey(key)

  VueCookie.set(newKey, value || '', options)
}

const getValue = (key: string): string | boolean | null => {
  const newKey = transformKey(key)
  const value = VueCookie.get(newKey)

  if (value === 'true') {
    return true
  }

  if (value === 'false') {
    return false
  }

  return value || null
}

const deleteValue = (key: string): void => {
  const newKey = transformKey(key)
  VueCookie.delete(newKey)

  if (window.location.hostname.includes(configs.domain)) {
    VueCookie.delete(newKey, {
      domain: configs.domain,
    })
  }
}

export default {
  deleteValue,
  setValue,
  setValueByDomain,
  getValue,
}
